module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#edit",
      toString: function () {
        return this.url;
      }
    }